"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Modal = require("./Modal");

var _Modal2 = _interopRequireDefault(_Modal);

var _VoucherUtil = require("../../utils/VoucherUtil");

var util = _interopRequireWildcard(_VoucherUtil);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherPreviewModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VoucherPreviewModal, _Component);

  function VoucherPreviewModal() {
    (0, _classCallCheck3.default)(this, VoucherPreviewModal);
    return (0, _possibleConstructorReturn3.default)(this, (VoucherPreviewModal.__proto__ || (0, _getPrototypeOf2.default)(VoucherPreviewModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(VoucherPreviewModal, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          voucher = _props.voucher,
          voucherNumber = _props.voucherNumber;

      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({ title: "Lipukkeen tiedot", noBottom: true }, this.props),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-8 col-xs-offset-2" },
              _react2.default.createElement(
                "h2",
                { className: "h3 mp-modal-title" },
                "Tilausnumero ",
                voucher.order_id,
                ", lipuke nro: ",
                voucherNumber
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12" },
              _react2.default.createElement("div", { className: "hairline" })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12 " },
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "LIPUKE OIKEUTTAA TUOMAAN YLIJ\xC4\xC4M\xC4 MAA-AINEKSIA ALLA ILMOITETULLE VASTAANOTTOPAIKALLE"
                )
              ),
              _react2.default.createElement(
                "p",
                null,
                "Lippukeiden k\xE4ytt\xF6m\xE4\xE4r\xE4t kuormakoon mukaan."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Lipukkeen ostanut: ",
                util.createBuyerName(voucher),
                _react2.default.createElement("br", null),
                "Lipukkeen numero: ",
                voucherNumber
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  voucher.name
                ),
                _react2.default.createElement("br", null),
                voucher.address,
                ", ",
                voucher.postal_code,
                " ",
                voucher.city,
                _react2.default.createElement("br", null),
                voucher.phone,
                _react2.default.createElement("br", null),
                voucher.description
              ),
              _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "table",
                  null,
                  _react2.default.createElement(
                    "thead",
                    null,
                    _react2.default.createElement(
                      "tr",
                      null,
                      _react2.default.createElement(
                        "th",
                        null,
                        _react2.default.createElement(
                          "b",
                          null,
                          "alv 0%"
                        )
                      ),
                      _react2.default.createElement(
                        "th",
                        null,
                        _react2.default.createElement(
                          "b",
                          null,
                          "alv 25.5%"
                        )
                      ),
                      _react2.default.createElement(
                        "th",
                        null,
                        _react2.default.createElement(
                          "b",
                          null,
                          "sis. alv 25.5%"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "tbody",
                    null,
                    _react2.default.createElement(
                      "tr",
                      null,
                      _react2.default.createElement(
                        "td",
                        null,
                        util.priceWithoutVAT(voucher)
                      ),
                      _react2.default.createElement(
                        "td",
                        null,
                        util.vatAmount(voucher)
                      ),
                      _react2.default.createElement(
                        "td",
                        null,
                        util.priceWithVAT(voucher)
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return VoucherPreviewModal;
}(_react.Component), _class.propTypes = {
  isShowingModal: _react.PropTypes.bool.isRequired,
  handleClose: _react.PropTypes.func.isRequired,
  printPath: _react.PropTypes.object.isRequired,
  voucher: _react.PropTypes.object.isRequired,
  voucherNumber: _react.PropTypes.number,
  fields: _react.PropTypes.object.isRequired
}, _temp);
exports.default = VoucherPreviewModal;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/modal/VoucherPreviewModal.js
 ** module id = 1166
 ** module chunks = 0
 **/